import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatErr(detail) {
  if (detail == null) return "Erro inesperado";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
  } catch {
    return iso;
  }
}

export function fmtMinutes(m) {
  if (!m && m !== 0) return "—";
  const h = Math.floor(m / 60);
  const mm = m % 60;
  if (h === 0) return `${mm}min`;
  return `${h}h ${mm}min`;
}

export const STATUS_COLORS = {
  "Aberta": "bg-red-500/10 text-red-700 border-red-500/30 dark:text-red-400",
  "Em Andamento": "bg-yellow-500/10 text-yellow-700 border-yellow-500/30 dark:text-yellow-400",
  "Concluída": "bg-green-500/10 text-green-700 border-green-500/30 dark:text-green-400",
  "Cancelada": "bg-slate-500/10 text-slate-700 border-slate-500/30 dark:text-slate-400",
};

export const PRIORITY_COLORS = {
  "Baixa": "bg-slate-500/10 text-slate-700 border-slate-500/30 dark:text-slate-400",
  "Média": "bg-blue-500/10 text-blue-700 border-blue-500/30 dark:text-blue-400",
  "Alta": "bg-orange-500/10 text-orange-700 border-orange-500/30 dark:text-orange-400",
  "Crítica": "bg-red-500/10 text-red-700 border-red-500/30 dark:text-red-400",
};

// Fetch wrapper that reuses same-origin cookie auth (no manual header needed)
export async function apiFetch(path, opts = {}) {
  const res = await fetch(`${API}${path}`, { credentials: "include", ...opts });
  return res;
}
